import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingPlanSuggestion } from '@zero/saving-plans/domain';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'saving-plans-saving-plan-suggestion-item',
  templateUrl: './saving-plan-suggestion-item.component.html',
  styleUrls: ['./saving-plan-suggestion-item.component.scss'],
  imports: [InstrumentDetailsLinkComponent, RouterLink, TranslocoPipe],
})
export class SavingPlanSuggestionItemComponent {
  @Input() public suggestion: SavingPlanSuggestion;
  @Input() public suggestionPercentage: string;
  @Input() public color: string;

  public readonly savingPlanMaskUrl = commonRoutes.postlogin.add_savings_plan;
}
